export default "__VITE_ASSET__CcpO2ASq__"